import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '@/assets/home/logo.png';
import logoWhiteImg from '@/assets/home/logo-white.png';
import { Dropdown, Space } from 'antd';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import sfsImg from '@/assets/images/sfs.png';
import gsImg from '@/assets/images/gs.png';
import './index.css';

const Header = (props) => {
  const pageName = props.pageName;
  const navigate = useNavigate();

  const items = [
    {
      key: '2',
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => goPage('/result')}
        >
          智能报警施封锁
        </a>
      ),
      icon: <img src={sfsImg} style={{ width: 30, height: 30 }} />,
    },
    {
      key: '3',
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => goPage('/resultgs')}
        >
          智能报警挂锁
        </a>
      ),
      icon: <img src={gsImg} style={{ width: 30, height: 30 }} />,
    },
  ];

  const goPage = (path) => {
    navigate(path);
  };

  return (
    <div className="top-tabs">
      <div className="top-flex">
        <img
          alt=""
          src={
            pageName === 'home' || pageName === 'resultgs'
              ? logoImg
              : logoWhiteImg
          }
          className="top-logo"
        />
        <div
          className="logo-name"
          style={
            pageName === 'home' || pageName === 'resultgs'
              ? {}
              : { color: '#ffffff' }
          }
        >
          鸿凯瑞达
        </div>
      </div>
      <div
        className={pageName === 'home' ? 'active' : ''}
        onClick={() => goPage('/')}
        style={
          pageName === 'home'
            ? { color: '#083865', fontWeight: 'bold' }
            : pageName === 'resultgs'
            ? { color: '#666666' }
            : { color: '#ffffff' }
        }
      >
        首页
      </div>
      <Dropdown menu={{ items }} placement="bottom" arrow>
        <div
          className={
            pageName === 'result' || pageName === 'resultgs'
              ? 'active'
              : pageName === 'home'
              ? 'divBlack'
              : ''
          }
        >
          产品
        </div>
      </Dropdown>
      <div
        className={
          pageName === 'aboutus'
            ? 'active'
            : pageName === 'home'
            ? 'divBlack'
            : ''
        }
        onClick={() => goPage('/aboutus')}
        style={
          pageName === 'home' || pageName === 'resultgs'
            ? { color: '#666666' }
            : pageName === 'aboutus'
            ? { color: '#083865' }
            : { color: '#ffffff' }
        }
      >
        关于我们
      </div>
    </div>
  );
};

export default Header;
